export default "__VITE_ASSET__CxgKP_Ib__"